import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ProjectCard from "../components/project/ProjectCard";
import CreateBanner from "../components/common/CreateBanner";
import { getProjectList } from "../api/ProjectAPI";
import { useProjectMEditStore, useCustomAlertStore } from "../Store/store";
import { useNavigate } from "react-router-dom";

const Main = styled.main`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  color: #fff;
  padding: 100px 50px 0px 50px;
  box-sizing: border-box;
  .project-header {
    display: flex;
    gap: 10px;
    flex-direction: column;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    padding-bottom: 20px;
    margin-bottom: 20px;
    h1 {
      font-size: 24px;
      font-weight: 700;
      color: #fff;
    }
    p {
      color: rgba(255, 255, 255, 0.33);
      font-size: 15px;
    }
  }

  .project-card-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 20px;
  }

  @media (max-width: 600px) {
    padding: 70px 20px 0px 20px;
    .project-card-container {
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    }

    .project-header {
      h1 {
        font-size: 20px;
      }
      p {
        font-size: 13px;
      }
    }
  }
`;

const EmptyState = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 18px;
  font-weight: 500;
  pointer-events: none;
  z-index: 0;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

const ProjectCardContainerWrapper = styled.div`
  position: relative;
  min-height: 300px;
`;

export default function Project() {
  const [projectList, setProjectList] = useState([]);
  const { isProjectMEditOpen } = useProjectMEditStore();
  const { showInfoAlert } = useCustomAlertStore();
  const navigate = useNavigate();
  const [reload, setReload] = useState(false);

  useEffect(() => {
    const fetchProjectList = async () => {
      try {
        const response = await getProjectList();

        setProjectList(response);
      } catch (error) {
        console.error("프로젝트 목록 조회 실패:", error);
        if (error?.response?.status === 403) {
          showInfoAlert("인증 오류", "로그인이 필요합니다. 다시 로그인해 주세요.", () => navigate("/"));
        }
      }
    };
    fetchProjectList();
  }, [isProjectMEditOpen, reload]);
  return (
    <Main>
      <CreateBanner
        title="프로젝트 매니저 추가"
        description="프로젝트 매니저를 추가할 수 있습니다."
        link="/project/create"
      />
      <div className="project-container">
        <header className="project-header">
          <h1>프로젝트 매니저 관리</h1>
          <p>관리중인 프로젝트 매니저를 확인할 수 있습니다.</p>
        </header>
        <ProjectCardContainerWrapper>
          {projectList.length === 0 && (
            <EmptyState>프로젝트가 없습니다</EmptyState>
          )}
          <div className="project-card-container">
            {projectList.map((project) => (
              <ProjectCard
                key={project.id}
                index={project.id}
                projectName={project.name}
                projectDescription={project.description}
                createdAt={project.createdAt}
                projectCount={project.projectCount}
                setReload={setReload}
              />
            ))}
          </div>
        </ProjectCardContainerWrapper>
      </div>
    </Main>
  );
}
